import SafeImage from '@ui/SafeImage';
import { ProductDocument } from 'models/product';
import { getProductSlug } from '@util/urlHelpers';
import { cn } from '@util/index';
import Link from 'next/link';
import ProductPriceRange from '@ui/ProductPriceRange';

interface ProductInfoProps {
  product: ProductDocument;
  titleClassName?: string;
}
const ProductInfo = ({ product, titleClassName }: ProductInfoProps) => (
  <div className="flex items-center gap-[1.2rem]">
    <Link href={getProductSlug(product)} className="shrink-0">
      <SafeImage
        key={product.images[0]?.thumb}
        className="h-[6.4rem] w-[6.4rem] rounded-2xl "
        alt={'product image for ' + product.title}
        src={product.images[0]?.thumb}
      />
    </Link>
    <div className="flex flex-col gap-[0.2rem]">
      <Link
        className={cn(
          'leading-[2.2rem] text-brand-lightest-black',
          titleClassName
        )}
        href={getProductSlug(product)}
      >
        {product.title}
      </Link>
      <ProductPriceRange product={product} />
    </div>
  </div>
);

export default ProductInfo;
